var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component"},[_c('div',{staticClass:"sliderImage"},[_c('img',{attrs:{"src":_vm.image.path}})])])}
var staticRenderFns = []

export { render, staticRenderFns }